import { InvestmentTrackingModeOption } from "../../types";
import { TRACKING_MODE_LABELS } from "../../constants";
import { InvestmentFormValues } from "./types";

export const FORM_ID = "investment";

export const DEFAULT_INVESTMENT: InvestmentFormValues = {
  name: "",
  institution: "",
  investmentType: null,
  trackingMode: null,
  startDate: new Date(),
  cashSettlement: "OWN_CASH",
  settlementAccount: null,
};

export const TRACKING_MODE_OPTIONS: InvestmentTrackingModeOption[] = [
  {
    value: "MANUAL_MARKET_UPDATES",
    label: TRACKING_MODE_LABELS.MANUAL_MARKET_UPDATES,
  },
  { value: "HOLDINGS_LEDGER", label: TRACKING_MODE_LABELS.HOLDINGS_LEDGER },
];
